import * as yup from "yup";
import { portugues } from "_utils/validador";

yup.setLocale(portugues);

export const FiltrosGerenciarPagamentoSchema = yup.object().shape({
  idsLotes: yup.array().of(yup.mixed()).optional().nullable(),
  idsNfRecibo: yup.array().of(yup.string()).optional().nullable(),
  idsProcessos: yup.array().of(yup.mixed()).optional().nullable(),
  idEmpresa: yup.number().optional().nullable(),
  idsBeneficiarios: yup.array().of(yup.number()).optional().nullable(),
  placa: yup.string().optional().nullable(),
  idsCustos: yup.array().of(yup.number()).optional().nullable(),
  possuiArquivoRecibo: yup.boolean().optional().nullable(),
  idUsuario: yup.number().optional().nullable(),
  periodo: yup.array().optional().nullable(),
});
